import LoadingButton from "@mui/lab/LoadingButton"
import Button from "@mui/material/Button"
import Dialog from "@mui/material/Dialog"
import DialogActions from "@mui/material/DialogActions"
import DialogContent from "@mui/material/DialogContent"
import Typography from "@mui/material/Typography"

import { WORKFLOW_STATUS } from "../utils"
import { useUpdateWorkflowStatus } from "./utils"

export default function ActivateWorkflowDialog({ open, onClose, workflow }) {
  const { isUpdatingStatus, updateStatus } = useUpdateWorkflowStatus()

  function handleActivateButtonClicked() {
    updateStatus(workflow, WORKFLOW_STATUS.live, onClose)
  }

  function handleSoftClose() {
    onClose()
  }

  return (
    <Dialog open={open} onClose={handleSoftClose} maxWidth="xs" fullWidth>
      <DialogContent>
        <Typography variant="body1">
          Are you sure you want to activate this workflow? All matching
          candidates will start entering this workflow and receive campaigns.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" color="primary" onClick={handleSoftClose}>
          Cancel
        </Button>
        <LoadingButton
          variant="contained"
          color="success"
          loading={isUpdatingStatus}
          onClick={handleActivateButtonClicked}
        >
          Activate
        </LoadingButton>
      </DialogActions>
    </Dialog>
  )
}
